module.exports = __webpack_public_path__ + "static/img/3.07d7c25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rarity/3.png
// module id = LZxp
// module chunks = 0